import React, { useState } from "react";

import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClientNew from "../helper/BaseclientNew";

const useContents = () => {
  const [contentsList, setContentsList] = useState(null);
  const [contentLoading, setContentLoading] = useState(false);
  const [sortedContents, setSortedContents] = useState(null);

  const fetchAllContentsData = async (token) => {
    try {
      setContentLoading(true);

      await BaseClientNew.get(APIEndpoints.fetchAllContents, {
        onSuccess: (res) => {
          if (res && res.data) {
            setContentsList(res.data);
          }
        },
        onFailed: (err) => {
          console.log("Error on fething CMS contents", err);
        },
      });
    } finally {
      setContentLoading(false);
    }
  };

  const fetchAllContentsDataNew = async (token) => {
    try {
      setContentLoading(true);

      await BaseClientNew.get(APIEndpoints.fetchAllContentsAltered, {
        onSuccess: (res) => {
          if (res && res.data) {
            setSortedContents(res.data);
          }
        },
        onFailed: (err) => {
          console.log("Error on fething CMS contents", err);
        },
      });
    } finally {
      setContentLoading(false);
    }
  };

  const updateContent = async (payload, { onSuccess, onFailed }) => {
    try {
      setContentLoading(true);

      await BaseClientNew.put(APIEndpoints.updateContentDetails, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setContentLoading(false);
    }
  };

  const createContent = async (payload, { onSuccess, onFailed }) => {
    try {
      setContentLoading(true);

      await BaseClientNew.post(APIEndpoints.createNewContent, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setContentLoading(false);
    }
  };

  return {
    fetchAllContentsData,
    fetchAllContentsDataNew,
    contentsList,
    contentLoading,
    sortedContents,
    updateContent,
    createContent,
  };
};

export default useContents;
